import { Container } from 'react-bootstrap'
import './advertisment.scss'
import { observer } from 'mobx-react-lite'
import { useTranslation } from 'react-i18next'

const Advertisment = () => {
  const { t } = useTranslation()
  return (
    <>
      <Container className='post-details-main-info ms-0'>
        <div className='pb-3 d-flex flex-column justify-content-between flex-md-row'>
          <p>{t('advertisment.find_right_mortgage')}</p>
          <img
            src='https://www.ubs.com/etc/designs/fit/img/UBS_Logo_Semibold.svg'
            alt='UBS Logo'
            className='ad-icon-svg'
          />
        </div>
        <button className='ad-button'>
        {t('advertisment.get_started')}
          
        </button>
      </Container>
    </>
  )
}

export default observer(Advertisment);
